export async function uploadFileToPresignedURL(
  presignedURL: string,
  file: File
): Promise<Response> {
  const response = await fetch(presignedURL, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });
  return response;
}

export async function speechToTextSuggestion(
  text: string,
  selectedText: string
): Promise<{ role: string; content: string; maskedSummary: string; summaryMessage: string }> {
  const requestBody = {
    message: text,
    selectedText,
  };
  const response = await fetch(`${process.env.REACT_APP_AUTH_SERVICE}/summary/summarize`, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error('Error fetching speech to text suggestion');
  }
  const data = await response.json();
  return data;
}

export default uploadFileToPresignedURL;
